import React from 'react';
import {WithTemplate} from '@morningtrain/react-app';
import * as Fields from "support/fields";
import {Form} from "@morningtrain/react-resources";
import { Translation } from '@morningtrain/react-translations'

export default function ForgotPassword() {
    return (
        <WithTemplate template={'Auth'}>
            <Form route={'auth.password.forgot_password'} >

                <div className="form-content login">
                    <Fields.Input
                        name='email'
                        label={<Translation name='fields.email.label' />}
                        required
                        autoFocus
                    />
                </div>

                <div className="mt-6">
                        <span className="block w-full rounded-md shadow-sm">
                             <button
                                 type='submit'
                                 className={'w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-500 hover:bg-primary-400 focus:outline-none focus:border-primary-700 focus:shadow-outline-primary active:bg-primary-700 transition duration-150 ease-in-out'}>
                                <Translation name='auth.actions.reset_password' />
                             </button>
                        </span>
                </div>
            </Form>
        </WithTemplate>
    );
}
